var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFramework7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 70.29 122.88"
    },
    viewBox: "0 0 70.29 122.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.88 61.44c0-5.83 2.06-11.18 5.49-15.37h37.56l-26.8 38.28c-9.46-3.31-16.25-12.32-16.25-22.91zm45.04-12.55c2.22 3.66 3.5 7.96 3.5 12.55 0 13.4-10.86 24.27-24.27 24.27-1.61 0-3.17-.16-4.69-.45l25.46-36.37zm-36.36-6.05c4.22-3.53 9.65-5.66 15.58-5.66s11.37 2.13 15.58 5.66H19.56z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ee350f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.26 0h43.76C60.67 0 64 1.49 66.4 3.88c2.4 2.4 3.89 5.73 3.89 9.38v96.36a13.268 13.268 0 0 1-13.27 13.26H13.26c-3.65 0-6.98-1.49-9.38-3.88-2.39-2.4-3.88-5.73-3.88-9.38V13.26c0-3.65 1.49-6.98 3.89-9.38C6.28 1.49 9.61 0 13.26 0zm53.83 104.67V13.69H3.18v90.96c22.23.01 41.69.02 63.91.02z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFramework7);
export default __webpack_public_path__ + "static/media/framework-7.91b43b176b00ea7d79d1e057d8c070be.svg";
export { ForwardRef as ReactComponent };